import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { NotificationProvider } from './context/NotificationContext';
import { WalletProvider, useWallet } from './context/WalletContext';
import { UserDataProvider } from './context/UserDataContext';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import BottomNav from './components/layout/BottomNav';
import StarfieldBg from './components/common/StarfieldBg';
import NetworkBanner from './components/common/NetworkBanner';

import Home from './pages/Home';
import Register from './pages/Register';
import Packages from './pages/Packages';
import Royalty from './pages/Royalty';
import Matrix from './pages/Matrix';
import Team from './pages/Team';
import Activity from './pages/Activity';
import Admin from './pages/Admin';
import NotFound from './pages/NotFound';

import './App.css';

const AppShell = () => {
  const { connected } = useWallet();
  return (
    <div className={'app-shell' + (connected ? ' has-bottom-nav' : '')}>
      <StarfieldBg />
      <Navbar />
      <NetworkBanner />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        {/* /dashboard is retired — home shows the dashboard for connected users */}
        <Route path="/dashboard" element={<Navigate to="/" replace />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/royalty" element={<Royalty />} />
        <Route path="/matrix" element={<Matrix />} />
        <Route path="/team" element={<Team />} />
        <Route path="/activity" element={<Activity />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      <BottomNav />
    </div>
  );
};

const App = () => (
  <BrowserRouter>
    <NotificationProvider>
      <WalletProvider>
        <UserDataProvider>
          <AppShell />
        </UserDataProvider>
      </WalletProvider>
    </NotificationProvider>
  </BrowserRouter>
);

export default App;
